import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import styles from './contentWithEyeColumn.module.scss';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

export type ContentWithEyeColumnProps = {
  value: string | number;
  iconClassName?: string;
  className?: string;
  contentData?: {
    component: any;
    props: any;
  },
  tooltipProps: {
    id: string,
    tooltip: string
  },
  onClickBtn: () => void;
  contentDataGetter?: (value: any) => {
    component: any;
    props: any;
  };
};

export const ContentWithEyeColumn = ({
  value,
  className,
  iconClassName,
  contentData,
  tooltipProps,
  onClickBtn,
  contentDataGetter
}: ContentWithEyeColumnProps) => {

  if (contentDataGetter) {
    const dataFromGetter = contentDataGetter(value);
    const {
      component,
      props
    } = dataFromGetter;
    const Component = component;

    return (
      <div className={cx(className, styles.cell)}>
        <Component {...props} />
        <IconWithTooltip
          placement='right'
          className={cx(styles.hoverBtns, iconClassName)}
          onClick={onClickBtn}
          icon={faEye}
          tooltipProps={tooltipProps}
        />
      </div>
    );
  }
  const Component = contentData?.component;
  return (
    <div className={cx(className, styles.cell)}>
      {contentData ? (
        <Component {...contentData.props} />
      ) : (
        <div style={{ marginRight: '7px' }}>{value}</div>
      )}
      <IconWithTooltip
        placement='right'
        className={cx(styles.hoverBtns, iconClassName)}
        onClick={onClickBtn}
        icon={faEye}
        tooltipProps={tooltipProps}
      />
    </div>
  );
};
